import React from 'react'
import { format, addMonths } from 'date-fns'
import Calendar from './calendar'
import { Toggle, Input } from './common'


export const visibleItems = function () {
	const { crono_groups, crono_visible_items } = hp.settings
	const items = {
		selected: crono_visible_items || 0,
		config: {
			1: __('coursesessions_view_intership'),
			2: __('coursesessions_view_coordinator'),
			4: __('coursesessions_view_mediator'),
			4096: __('coursesessions_view_responsible'),
			8192: "(" + __('coursesessions_view_all') + ")"
		}
	}

	for (let i of [2, 4, 4096, 8192]) {
		if ((crono_groups & i) == 0) {
			delete items.config[i]
		}
	}
	const onClick = (e) => {
		e.stopPropagation()
		if (e.currentTarget.getAttribute('disabled') === '') {
			return;
		}
		const idx = Number(e.currentTarget.getAttribute('data-item'))

		items.selected = (items.selected & idx) == idx
			? (items.selected - (items.selected & idx))
			: (items.selected | idx)
		hp.settings.crono_visible_items = items.selected
		self.onMenuClick(e)
	}
	const onExport = (e) => {
		const data = {
			groups: {}
		}
		mbox.modal(<Export data={data} />, {
			title: "Exportar",
			buttons: [
				{
					type: 'primary',
					icon: 'share',
					text: 'Exportar',
					onClick: () => {
						let groups = Object.keys(data.groups).filter(group_id => data.groups[group_id])
						const internship = (crono_groups & 1) == 1 ? '&internship=1' : ''

						groups = encodeURIComponent(JSON.stringify(groups))
						window.location.href = `/usercalendar/export.personal?groups=${groups}&start=${data.datepicker_start}&end=${data.atepicker_end}'&company=${hp.settings.title}${internship}`;
						//mbox.dismiss()
					}
				},
				'close'
			]
		})
	}
	const self = {
		render: () => {
			const { crono_can_export } = hp.settings
			const _items = []

			if (crono_can_export) {
				_items.push(
					<li key="-1">
						<a title={__('coursesessions_export_session_button_title')} onClick={onExport}>
							<em className="la la-share" />
							<span>{__('coursesessions_export_session_button')}</span>
						</a>
					</li>
				)
				_items.push(<li key="-2" className='divider' />)
			}
			for (const [i, label] of Object.entries(items.config)) {
				const disabled = i > 1 && i < 8192 && (items.selected & 8192) == 8192
				_items.push(
					<li key={i} className='py-1' onClick={onClick} data-item={i} disabled={disabled}>
						<Toggle checked={(items.selected & i) == i} disabled={disabled} label={label} />
					</li>
				)
			}
			_items.push(<li key="-3" className='divider' />)
			_items.push(
				<li key="-4">
					<a href="/tips/show/coursesession-cronogram.help" target="_blank">
						<em className="la la-exclamation-circle" />
						<span>{__('attrs_help')}</span>
					</a>
				</li>
			)
			return _items
		},
		selected: () => items.selected
		//isVisible: (item) => (items.selected & item) == item
	}
	return self
}

const eventTypes = {
	//'-2': {url: '/tests/trainee/{courseaction_id}.personal'},
	'-2': { url: '/testevents/info/{id}.ajax' },
	2: { url: '/courseactions/trainee_works/{courseaction_id}.personal' },
	3: { url: '/coursesessions/info/{id}.ajax' },
	4: { url: '/coursesessions/info/{id}.ajax', goto: { text: __('coursesessions_summary_presences'), url: '/coursesessions/show/{id}.personal' } },
	//4: {url: '/coursesessions/show/{id}.personal'},
	5: { url: '/vehicles/edit_usage/{id}.ajax' }
}

class Export extends React.Component {
	constructor(props) {
		super(props)
		const { groups } = props.data
		this.user_groups = hp.settings.user_groups.filter(group_id => group_id >= 2 && group_id <= 4)
		this.user_groups.forEach(group_id => groups[group_id] = true)

		props.data.datepicker_start = format(new Date(), 'Y-MM-d')
		props.data.datepicker_end = format(addMonths(new Date(), 1), 'Y-MM-d')
	}

	render() {
		const { data } = this.props
		const items = this.user_groups.map(group_id => (
			<li key={group_id} className='list-group-items'>
				<Toggle model={data.groups} name={group_id} label={__(`coursesessions_my_session_as_group_${group_id}`)} />
			</li>
		))

		return (
			<div className='pcontent'>
				<ul className='list-group'>
					{items}
				</ul>
				<hr />
				<div className="flex">
					<label class="control-label">{__("coursesessions_export_between")}</label>
					<Input type="date" model={data} name="datepicker_start" class="form-control input-sm" title={__("coursesessions_export_start_title")} />
					<label class="control-label mx-1">{__("attrs_and")}</label>
					<Input type="date" model={data} name="datepicker_end" class="form-control input-sm" title={__("coursesessions_export_end_title")} />
				</div>
			</div>
		)
	}
}

export default class UserCronogram extends React.Component {
	constructor(props) {
		super(props)
		const view = sessionStorage.getItem('calendar.cronogram') || 'week'
		const { start, end } = Calendar.getRangeFor(view)
		this.state = {
			view: view,
			events: {},
			date: new Date(),
			start: start,
			end: end,
			selectedEvents: [],
		}
		this.visible_items = props.visible_items || visibleItems()
		this.visible_items.onMenuClick = this.onMenuClick
	}

	componentDidMount() {
		this.loadData()
	}

	loadData() {
		const { start, end } = this.state
		const params = {
			evt_start: `${start.getFullYear()}-${start.getMonth() + 1}-${start.getDate()}`,
			evt_end: `${end.getFullYear()}-${end.getMonth() + 1}-${end.getDate()}`,
			items: this.visible_items.selected()
		}
		http.get('/users/cronogram.json', params, (response, success) => {
			if (success) {
				response.events.forEach(event => {
					event.start = new Date(event.start)
					event.end = new Date(event.end)
				})
				this.state.events[start.getTime()] = {
					start: start,
					end: end,
					data: response.events
				}
				for (let event of response.events) {
					event.foreColor = hp.html.deriveTextColorFrom(event.color)
				}
				this.setState({
					selectedEvents: response.events
				})
				if (this.props.onAfterLoad) {
					this.props.onAfterLoad()
				}
			}
		})
	}

	onMenuClick = (e) => {
		this.setState({ events: {} })
		this.loadData()
	}

	onViewChanged = (view) => {
		sessionStorage.setItem('calendar.cronogram', view)
		this.state.view = view
		this.onNavigate(this.state.start)
	}

	onNavigate = (date) => {
		const { view, events } = this.state
		const { start, end } = Calendar.getRangeFor(view, date)
		const time = start.getTime()

		if (events.hasOwnProperty(time) && events[time].end <= end) {
			this.setState({
				selectedEvents: events[time].data,
				date: date,
				start: start,
				end: end
			})
			return
		}
		// procura uma lista de eventos cujas datas estejam compreendidas
		for (const [_start, _events] of Object.entries(events)) {
			if (start >= _events.start && end <= _events.end) {
				this.setState({
					selectedEvents: _events.data,
					date: date,
					start: start,
					end: end
				})
				return
			}
		}
		this.state.start = start
		this.state.end = end
		this.loadData()
		this.setState({ date, date })
	}

	onSelectEvent = (event, e) => {
		// based on event type, build the link
		if (!eventTypes.hasOwnProperty(event.gid)) {
			return
		}
		const event_type = eventTypes[event.gid]
		const url = event_type.url.replace(/\{(\w+)\}/, (str, param) => event.hasOwnProperty(param) ? event[param] : '')

		// if ajax url, call dialog
		if (/\.ajax$/.test(url)) {
			const buttons = ["close"]
			let after = null

			if (event_type.goto) {
				buttons.unshift({
					type: 'primary',
					text: event_type.goto.text,
					icon: 'la la-external-link',
					click: () => {
						const url_goto = event_type.goto.url.replace(/\{(\w+)\}/, (str, param) => event.hasOwnProperty(param) ? event[param] : '')
						location.href = url_goto
					}
				})
			}
			if (event.gid == 5) {
				buttons.unshift({
					text: humanportal.regional.vehicles.navigate,
					icon: "la la-external-link",
					click: function () {
						window.location = "/vehicles.personal"
					}
				})
				after = function (dv) {
					dv.find("form :input").attr({
						disabled: "disabled",
						readonly: ""
					}).removeAttr("readonly");
				}
			}
			else if (event.gid == -2 && event.canReply == 1) {
				buttons.unshift({
					text: humanportal.regional.tests.respond,
					icon: "la la-reply",
					click: function () {
						hp.helpers.openPopup(`/testevents/show/${event.id}.popup`);
						$(this).blur();
					}
				});
			}
			hp.ui.dialog.create(
				url,
				buttons,
				{ attrs: "callendar_events", title: event.title },
				after
			);
		}
		else if (url) {
			window.open(url, '_blank')
		}
	}

	render() {
		const { selectedEvents, date, view } = this.state

		return (
			<Calendar
				view={view}
				events={selectedEvents}
				date={date}
				onSelectEvent={this.onSelectEvent}
				onNavigate={this.onNavigate}
				//onRangeChange={this.onRangeChange}
				onViewChanged={this.onViewChanged}
				startAccessor="start"
				endAccessor="end"
				eventPropGetter={(event, start, end, selected) => {
					return {
						style: {
							backgroundColor: event.color,
							borderColor: event.color,
							color: event.foreColor,
							opacity: event.prevision == 1 || event.equiv == 1 ? 0.5 : 1
						}
					};
				}}
				titleAccessor={e =>
					<>
						{this.state.view === 'month' && e.start && e.end && (
							<small>
								{`${format(e.start, 'HH:mm')} - ${format(e.end, 'HH:mm')}\n`}
							</small>
						)}
						{e.prevision == 1 ? <em className='la la-compass' title="Sessão prevista" /> : null}
						{e.equiv == 1 ? <em className='la la-retweet' title="Equivalência" /> : null}
						{e.summarized == 1 ? <em className='la la-check' title="Sessão com sumário lançado" /> : null}
						{e.title}
					</>
				}
				tooltipAccessor={e => e.title}
			/>
		)
	}
}
